import React, { useState, useEffect } from "react";
import { Map, Marker } from "google-maps-react";
import "./Mapa.component.scss";

const mapStyles = {
  width: "100%",
  height: "100%",
};

const MapaComponent = ({ google, marcadores = [] }) => {
  const [inicial, setInicial] = useState({
    lat: -34.5972822,
    lng: -58.3920078,
  });

  useEffect(() => {
    if (marcadores.length > 0) {
      const { lat, lng } = marcadores[0];
      setInicial({
        lat: lat,
        lng: lng,
      });
    }
  }, [marcadores]);

  return (
    <Map google={google} zoom={12} style={mapStyles} initialCenter={inicial}>
      {marcadores.map((marcador, index) => {
        return (
          <Marker
            key={index}
            id={index}
            title={marcador.Descripcion}
            position={{
              lat: marcador.lat,
              lng: marcador.lng,
            }}
          />
        );
      })}
    </Map>
  );
};

export default MapaComponent;
